// extracted by mini-css-extract-plugin
module.exports = {"cardRow":"styles_cardRow__1xJrn"};